export enum ModelNamesEnum {
  // Alex = 'alex',
  // Josephine = 'josephine',
  Leobot = 'Leobot'
}
export const modelsPath = "/models"

// Old model setup
// export enum AnimationsEnum {
//   IdleStarted = 'IdleStarted',
//   Idle = 'Idle',
//   Idle2 = 'Idle2',
//   Idle3 = 'Idle3',
//   Dance = 'Dance',
//   TalkStarted = 'TalkStarted',
//   Talk = 'Talk',
//   Talk2 = 'Talk2',
//   Talk3 = 'Talk3',
//   TalkIdle = 'TalkIdle',
//   Wave = 'Wave',
//   Think = 'Think',
//   Think2 = 'Think2',
//   ThinkStarted = 'ThinkStarted',
//   ThinkFinishedToTalk = 'ThinkFinishedToTalk',
//   ThinkFinishedToIdle = 'ThinkFinishedToIdle',
//   Interrupt = 'Interrupt',
//   Interrupt2 = 'Interrupt2',
//   Interrupt3 = 'Interrupt3',
//   Listen = 'Listen',
//   Listen2 = 'Listen2'
// }
// export const animationSettings = {
//   [AnimationsEnum.IdleStarted]: { fadeInDelay: 0.99, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Idle]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Idle2]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Idle3]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Dance]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.TalkStarted]: { fadeInDelay: 0.99, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Talk]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Talk2]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Talk3]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.TalkIdle]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Wave]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Think]: { fadeInDelay: 0.01, fadeOutDelay: 0.99, startFrame: 1000 },
//   [AnimationsEnum.Think2]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.ThinkStarted]: { fadeInDelay: 0.5, fadeOutDelay: 0.01, startFrame: 1000 },
//   [AnimationsEnum.ThinkFinishedToTalk]: { fadeInDelay: 0.99, fadeOutDelay: 0.99, startFrame: 1000 },
//   [AnimationsEnum.ThinkFinishedToIdle]: { fadeInDelay: 0.99, fadeOutDelay: 0.99, startFrame: 1000 },
//   [AnimationsEnum.Interrupt]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Interrupt2]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Interrupt3]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Listen]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 },
//   [AnimationsEnum.Listen2]: { fadeInDelay: 0.5, fadeOutDelay: 0.5, startFrame: 1000 }
// }
// export const defaultAnimationDelay = 0.5
// export const defaultAnimationStartFrame = 0
// export const blinkTick = 4000
// export const blinkDuration = 250



  // visemes ->
  // export enum VisemesEnum {
  //   VisemeAlveolar_Fricatives     = 'Alveolar_Fricatives',
  //   Back_Low_Unrounded            = 'Back_Low_Unrounded',
  //   Back_MidHigh_Rounded          = 'Back_MidHigh_Rounded',
  //   Back_MidLow_Rounded           = 'Back_MidLow_Rounded',
  //   Back_Rounded_Sounds           = 'Back_Rounded_Sounds',
  //   Bilabial_Consonants           = 'Bilabial_Consonants',
  //   Diphthong_AI                  = 'Diphthong_AI',
  //   Diphthong_AU                  = 'Diphthong_AU',
  //   Diphthong_OI                  = 'Diphthong_OI',
  //   Front_Row_Consonants          = 'Front_Row_Consonants',
  //   Front_Vowels_Semivowels       = 'Front_Vowels_Semivowels',
  //   Labiodental_Fricatives        = 'Labiodental_Fricatives',
  //   Lateral_Approximant           = 'Lateral_Approximant',
  //   Mid_Close_Vowels              = 'Mid_Close_Vowels',
  //   Mid_Open_Vowels               = 'Mid_Open_Vowels',
  //   PostAlveolar_Consonants       = 'PostAlveolar_Consonants',
  //   R_Like_Sound                  = 'R_Like_Sound',
  //   Rounded_MidClose_Rhotic       = 'Rounded_MidClose_Rhotic',
  //   Silence                       = 'Silence', 
  //   Velar_Consonants              = 'Velar_Consonants',
  //   Voiced_Interdental_Fricative  = 'Voiced_Interdental_Fricative',
  //   Voiceless_Glottal_Fricative   = 'Voiceless_Glottal_Fricative',
  // }

export enum BlandshapesEnum {
  Silence                     = '0_Silence',
  MidOpenVowels              = '1_Mid_Open_Vowels',
  BackLowUnrounded           = '2_Back_Low_Unrounded',
  BackMidLowRounded          = '3_Back_MidLow_Rounded',
  MidCloseVowels             = '4_Mid_Close_Vowels',
  RoundedMidCloseRhotic      = '5_Rounded_MidClose_Rhotic',
  FrontVowelsSemivowels      = '6_Front_Vowels_Semivowels',
  BackRoundedSounds          = '7_Back_Rounded_Sounds',
  BackMidHighRounded         = '8_Back_MidHigh_Rounded',
  DiphthongAU                = '9_Diphthong_AU',
  DiphthongOI                = '10_Diphthong_OI',
  DiphthongAI                = '11_Diphthong_AI',
  VoicelessGlottalFricative  = '12_Voiceless_Glottal_Fricative',
  RLikeSound                 = '13_R_Like_Sound',
  LateralApproximant         = '14_Lateral_Approximant',
  AlveolarFricatives         = '15_Alveolar_Fricatives',
  PostAlveolarConsonants     = '16_PostAlveolar_Consonants',
  VoicedInterdentalFricative = '17_Voiced_Interdental_Fricative',
  LabiodentalFricatives      = '18_Labiodental_Fricatives',
  FrontRowConsonants         = '19_Front_Row_Consonants',
  VelarConsonants            = '20_Velar_Consonants',
  BilabialConsonants         = '21_Bilabial_Consonants',
}

export enum AnimationsEnum {

  // IdleStarted = 'Waiting_Variation1',
  IdleStarted = 'Idle_1_1',
  // =================================================================
  Idle = 'Waiting_Variation1',
  Idle2 = 'Waiting_Variation2',
  Idle3 = 'Waiting_Variation3',
  TalkStarted = 'Speaking_NoGestures',
  // Talk = 'Speaking_NoGestures',
  Talk2 = 'Speaking_OptionalGestures',
  Talk3 = 'Speaking_WithGestures',
  // TalkIdle = 'Speaking_NoGestures',
  // Think = 'Thinking_Variation1',
  Think2 = 'Thinking_Variation2',
  Think3 = 'Thinking_Variation3',
  ThinkStarted = 'Thinking_Variation1',
  // ThinkFinishedToTalk = 'Thinking_Variation1',
  // ThinkFinishedToIdle = 'Thinking_Variation1',
  Interrupt = 'Interrupted_Upset',
  Interrupt2 = 'Interrupted_Surprised',
  Interrupt3 = 'Interrupted_Disappointed',
  Listen = 'Listening_Variation1',
  Listen2 = 'Listening_Variation2',
  Dance = 'Dance',
  Smile = 'Smile',
  Wave = 'Wave_Hand',
}

export const AnimationsWaitingArray = [
  AnimationsEnum.Idle,
  AnimationsEnum.Idle,
  AnimationsEnum.Idle,
  AnimationsEnum.Idle,
  AnimationsEnum.Idle2,
  AnimationsEnum.Idle3,
  AnimationsEnum.Idle3,
  AnimationsEnum.Idle3,
  AnimationsEnum.Idle3,
  AnimationsEnum.Idle3,
  AnimationsEnum.Dance,
  AnimationsEnum.Smile,
  AnimationsEnum.Wave,
  AnimationsEnum.Wave,
]
export const AnimationsListeningArray = [
  AnimationsEnum.Listen,
  AnimationsEnum.Listen2,
]
export const AnimationsTalkingArray = [
  AnimationsEnum.TalkStarted,
  AnimationsEnum.Talk2,
  AnimationsEnum.Talk3,
]
export const AnimationsThinkingArray = [
  AnimationsEnum.ThinkStarted,
  AnimationsEnum.ThinkStarted,
  AnimationsEnum.ThinkStarted,
  AnimationsEnum.ThinkStarted,
  AnimationsEnum.ThinkStarted,
  AnimationsEnum.Think2,
  AnimationsEnum.Think3,
]
export const AnimationsInterruptArray = [
  AnimationsEnum.Interrupt,
  AnimationsEnum.Interrupt2,
  AnimationsEnum.Interrupt3,
]

export enum FaceExpressionsEnum {
  FaceNeutral       = '0_Face_neutral',
  FaceSurprised     = '1_Face_Surprised',
  FaceSad           = '2_Face_Sad',
  FaceDisappointed  = '3_Face_Disappointed',
  FaceSatisfied     = '4_Face_Satisfied',
  FaceThinking      = '5_Face_Thinking',
}

// TODO: revisit on animations adjustment
export const animationSettings = {
  [AnimationsEnum.IdleStarted]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Idle]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Idle2]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Idle3]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.TalkStarted]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  // [AnimationsEnum.Talk]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Talk2]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Talk3]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  // [AnimationsEnum.TalkIdle]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  // [AnimationsEnum.Think]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Think2]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Think3]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.ThinkStarted]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  // [AnimationsEnum.ThinkFinishedToTalk]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  // [AnimationsEnum.ThinkFinishedToIdle]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Interrupt]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Interrupt2]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Interrupt3]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Listen]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Listen2]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Dance]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Smile]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },
  [AnimationsEnum.Wave]: { fadeInDelay: 0, fadeOutDelay: 0, startFrame: 0 },

}

export const defaultNoAnimationOption = 'No_animation'

export const defaultAnimationDelay = 0
export const defaultAnimationStartFrame = 0
export const blinkTick = 4000
export const blinkDuration = 250

export const voicesMap = {
  // [ModelNamesEnum.Alex]: 'en-US-AndrewNeural',
  // [ModelNamesEnum.Josephine]: 'en-US-CoraNeural'
  [ModelNamesEnum.Leobot]: 'en-US-AshleyNeural'
}

// viseme_sil
// viseme_PP
// viseme_FF
// viseme_TH
// viseme_DD
// viseme_kk
// viseme_CH
// viseme_SS
// viseme_nn
// viseme_RR
// viseme_aa
// viseme_E
// viseme_I
// viseme_O
// viseme_U

export const visemeSil = 'viseme_sil'

type VisemeMapItem = {
  visemeId: number,
  key: string,
  morphValue: number,
  speed: number,
  name: string,
}
export const visemesSettings = [
  { visemeId: 0, key: visemeSil, morphValue: 0, speed: 0.3, name: '0_Silence' },                       // [0]
  { visemeId: 1, key: 'viseme_aa', morphValue: 0.6, speed: 0.3, name: '1_Mid_Open_Vowels' },           // [1]
  { visemeId: 2, key: 'viseme_aa', morphValue: 0.6, speed: 0.3, name: '2_Back_Low_Unrounded' },        // [2]
  { visemeId: 3, key: 'viseme_O', morphValue: 0.5, speed: 0.3, name: '3_Back_MidLow_Rounded' },        // [3]
  { visemeId: 4, key: 'viseme_E', morphValue: 0.7, speed: 0.3, name: '4_Mid_Close_Vowels' },           // [4]
  { visemeId: 5, key: 'viseme_RR', morphValue: 0.4, speed: 0.3, name: '5_Rounded_MidClose_Rhotic' },   // [5]
  { visemeId: 6, key: 'viseme_I', morphValue: 0.5, speed: 0.3, name: '6_Front_Vowels_Semivowels' },    // [6]
  { visemeId: 7, key: 'viseme_U', morphValue: 0.7, speed: 0.3, name: '7_Back_Rounded_Sounds' },        // [7]
  { visemeId: 8, key: 'viseme_O', morphValue: 0.5, speed: 0.3, name: '8_Back_MidHigh_Rounded' },       // [8]
  { visemeId: 9, key: 'viseme_aa', morphValue: 0.6, speed: 0.3, name: '9_Diphthong_AU' },              // [9]
  { visemeId: 10, key: 'viseme_O', morphValue: 0.5, speed: 0.3, name: '10_Diphthong_OI' },              // [10]
  { visemeId: 11, key: 'viseme_I', morphValue: 0.5, speed: 0.3, name: '11_Diphthong_AI' },              // [11]
  { visemeId: 12, key: visemeSil, morphValue: 0.7, speed: 0.3, name: '12_Voiceless_Glottal_Fricative' },// [12]
  { visemeId: 13, key: 'viseme_RR', morphValue: 0.4, speed: 0.3, name: '13_R_Like_Sound' },             // [13]
  { visemeId: 14, key: 'viseme_RR', morphValue: 0.4, speed: 0.3, name: '14_Lateral_Approximant' },      // [14]
  { visemeId: 15, key: 'viseme_SS', morphValue: 0.4, speed: 0.6, name: '15_Alveolar_Fricatives' },      // [15]
  { visemeId: 16, key: 'viseme_CH', morphValue: 0.4, speed: 0.5, name: '16_PostAlveolar_Consonants' },  // [16]
  { visemeId: 17, key: 'viseme_TH', morphValue: 1, speed: 0.3, name: '17_Voiced_Interdental_Fricative' },// [17]
  { visemeId: 18, key: 'viseme_FF', morphValue: 0.6, speed: 0.3, name: '18_Labiodental_Fricatives' },   // [18]
  { visemeId: 19, key: 'viseme_DD', morphValue: 0.4, speed: 0.3, name: '19_Front_Row_Consonants' },     // [19]
  { visemeId: 20, key: 'viseme_kk', morphValue: 0.4, speed: 0.3, name: '20_Velar_Consonants' },         // [20]
  { visemeId: 21, key: 'viseme_PP', morphValue: 0.5, speed: 0.3, name: '21_Bilabial_Consonants' }       // [21]
] as VisemeMapItem[];
